import { render } from "./LeagueRankingView.vue?vue&type=template&id=486d6a16"
import script from "./LeagueRankingView.vue?vue&type=script&lang=js"
export * from "./LeagueRankingView.vue?vue&type=script&lang=js"

import "./LeagueRankingView.vue?vue&type=style&index=0&id=486d6a16&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__